module.exports = __webpack_public_path__ + "media/assets/images/banner@2x-b4cfbf7161ce3bf9b91ea23033b9d72c.png";